<template>
  <div class="s-homepage-company-registration">
    <img
      alt="company registration background"
      class="s-homepage-company-registration__background"
      :src="
        useCloudinary(
          'GRAPHIC_DESIGN/VISUALS_RESTYLING/homepage/homepage_vakspecialist_bg_02.jpg',
          { width: 1440, height: 'auto' },
        )
      "
    />
    <SAppContainer>
      <div class="s-homepage-company-registration__content">
        <SHeading color="primary" level="2" size="2">
          {{ tr("client.homepage.footer_cta_title") }}
        </SHeading>
        <p class="s-homepage-company-registration__description">
          {{ tr("client.homepage.footer_cta_description") }}
        </p>
        <SButton
          color="success"
          external
          suffix-icon="fas fa-arrow-right"
          :tag="NuxtLink"
          :to="ziggy('client.pro.customer_registration')"
        >
          {{ tr("client.homepage.footer_cta_button") }}
        </SButton>
      </div>
    </SAppContainer>
  </div>
</template>

<script setup lang="ts">
import { NuxtLink } from "#components";

import { SButton } from "@solvari/common-fe";
import { useCloudinary } from "@solvari/common-fe/integrations";
import { SAppContainer, SHeading } from "@solvari/components";
import { useI18nMainSiteHomepage } from "@solvari/translations";

import { ziggy } from "~/shared/libs/ziggy.ts";

const { tr } = useI18nMainSiteHomepage();
</script>

<style lang="postcss">
.s-homepage-company-registration {
  @apply relative h-full max-h-128;

  &__background {
    @apply absolute h-full w-full object-cover transition-all;
  }

  .s-app-container {
    @apply py-16;
  }

  &__content {
    @apply relative max-w-screen-600 space-y-6 rounded-bl-3xl rounded-tr-3xl bg-gray-50 px-6 py-8;
  }

  &__description {
    @apply text-gray-700;
  }
}

@screen 600 {
  .s-homepage-company-registration {
    &__content {
      @apply p-16;
    }

    &__description {
      @apply mb-6 text-lg;
    }
  }
}
</style>
